/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EInvoicingSettingsUpdateRequest
 */
export interface EInvoicingSettingsUpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof EInvoicingSettingsUpdateRequest
     */
    excludedFromAutomaticEInvoicing: boolean;
}

/**
 * Check if a given object implements the EInvoicingSettingsUpdateRequest interface.
 */
export function instanceOfEInvoicingSettingsUpdateRequest(value: object): value is EInvoicingSettingsUpdateRequest {
    if (!('excludedFromAutomaticEInvoicing' in value) || value['excludedFromAutomaticEInvoicing'] === undefined) return false;
    return true;
}

export function EInvoicingSettingsUpdateRequestFromJSON(json: any): EInvoicingSettingsUpdateRequest {
    return EInvoicingSettingsUpdateRequestFromJSONTyped(json, false);
}

export function EInvoicingSettingsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EInvoicingSettingsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'excludedFromAutomaticEInvoicing': json['excludedFromAutomaticEInvoicing'],
    };
}

export function EInvoicingSettingsUpdateRequestToJSON(value?: EInvoicingSettingsUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'excludedFromAutomaticEInvoicing': value['excludedFromAutomaticEInvoicing'],
    };
}

